import { createSlice } from '@reduxjs/toolkit';

import { uploadGarmentSpecificationFile, uploadGradingFile } from '../../apis';

export const getGarmentSpecificationsDetails = createSlice({
    name: 'shippingItems',
    initialState: {
        isLoading: false,
        data : [],
        error: '',
        uploadGarmentSpecificationsFileSuccess: false,
        uploadGradingFileSuccess: false,
    },

    reducers: {
        clearErrorState: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clearGarmentSpecificationsFileSuccess: (state, action) => {
            return {
                ...state,
                uploadGarmentSpecificationsFileSuccess: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(uploadGarmentSpecificationFile.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(uploadGarmentSpecificationFile.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.uploadGarmentSpecificationsFileSuccess = true;
        })
        builder.addCase(uploadGarmentSpecificationFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(uploadGradingFile.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(uploadGradingFile.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.uploadGradingFileSuccess = true;
        })
        builder.addCase(uploadGradingFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
       
    }
})

export const { clearErrorState, clearGarmentSpecificationsFileSuccess, clear } = getGarmentSpecificationsDetails.actions
export default getGarmentSpecificationsDetails.reducer     